export const formatPhoneNumberInput = (value: any): string => {
    const phoneNumber = value?.replace(/\D/g, '');
    
    const truncated = phoneNumber?.slice(0, 10);
    if (truncated?.length <= 3) {
        return truncated;
    } else if (truncated?.length <= 6) {
        return `(${truncated?.slice(0, 3)}) ${truncated?.slice(3)}`;
    } else {
        return `(${truncated?.slice(0, 3)}) ${truncated?.slice(3, 6)}-${truncated?.slice(6)}`;
    }
};

export const parsePhoneNumber = (formatted: string): string => {
    return formatted.replace(/\D/g, '');
};